import { useSuspenseQuery } from "@tanstack/react-query";
import { listDirectoryProtections } from "../openapi/api-client.ts";
import { ListDirectoryProtectionsError } from "../errors/ListDirectoryProtectionsError.ts";

export const useListDirectoryProtections = (projectId: string) =>
  useSuspenseQuery({
    queryKey: ["directoryProtections", { projectId }],
    queryFn: async () => {
      const response = await listDirectoryProtections({
        path: { projectId },
      });

      if (!response.data) {
        throw new ListDirectoryProtectionsError(
          `error while fetching directory protections: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
